module.exports = __webpack_public_path__ + "img/icon-scan-reset.b7c563f4.svg";